const GET_DEVICES = `
  query Devices($limit: Int, $deviceType: [DeviceType]) {
    devices(limit: $limit, deviceType: $deviceType) {
      items {
        deviceId
        identity {
          friendlyName
          serialNumber
          makeAndModel {
            name
            number
          }
        }
        images {
          url
        }
        type
      }
      totalCount
    }
  }
`;

export default GET_DEVICES;
